import { arrayToTree } from "@/utils/tree"
import { getDomainFieldList } from "../api/domain"
import { FieldType } from "../type"

// 获取域表格内容
export const getDomainTableData = async (params?: any) => {
    const resTable = await getDomainFieldList(params)
    const newData = resTable?.data ? resTable.data : resTable
    // 排序 sortNumber 字段，递增
    newData.sort((a, b) => a.sortNumber - b.sortNumber)
    newData.forEach(item => {
        if (item.fields) {
            item.fields.sort((a, b) => a.sortNumber - b.sortNumber)
            const fields = [...item.fields]
            const { tree } = arrayToTree(fields, {
                idField: "id",
                pidField: "parentId",
                keyField: "id",
                needValue: false,
                needChildField: false,
            })
            item.fields = tree
            // console.log('treeData', tree)
        }
    })
    newData.forEach(item => {
        if (item.fields) {
            item.children = item.fields
        }
        if (item.groupName) {
            item.fieldName = item.groupName
        }
        item.fields?.forEach(field => {
            if ([FieldType.DROPDOWN, FieldType.SINGLE_CHECKBOX, FieldType.CHECKBOX].includes(field.fieldType as FieldType)) {
                const jsonObj = JSON.parse(field.content)
                if (jsonObj.options) {
                    field.contentTemp = jsonObj.options.map(i => i.label).join(", ")
                }
            }
        })

    })
    return newData
}